"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.YOUTUBE_THUMBNAIL_PATTERN = void 0;
// https://i.ytimg.com/vi/JtUEEwVKj4c/(default|mqdefault|hqdefault|...).jpg
exports.YOUTUBE_THUMBNAIL_PATTERN = /^(?:https?:)?\/\/i\.ytimg\.com\/vi\/([^/]+)\/([^.]+)\.jpg$/;
// NOTE: `standard` and `maxres` sizes are skipped, because they may or may not exist for youtube video
var YOUTUBE_THUMBNAIL_SIZES = [
    {
        // Normal Quality Thumbnail
        name: 'mqdefault',
        width: 120,
        height: 90,
    },
    {
        // Medium Quality Thumbnail
        name: 'mqdefault',
        width: 320,
        height: 180,
    },
    {
        // High Quality Thumbnail
        name: 'mqdefault',
        width: 480,
        height: 360,
    },
];
/**
 * Get Youtube thumbnail image url with size that fits required `width` and `height`
 * @param {string} url
 * @param {number} width
 * @param {number} [height]
 * @returns {string}
 */
function resizeYoutubeThumbnail(url, width, height) {
    var thumbnailMatch = url.match(exports.YOUTUBE_THUMBNAIL_PATTERN);
    if (!thumbnailMatch) {
        return url;
    }
    var currentThumbnailSizeName = thumbnailMatch[2];
    var resizedThumbnailSize = YOUTUBE_THUMBNAIL_SIZES.find(function (thumbnailSize) {
        return thumbnailSize.width >= width &&
            (!height || thumbnailSize.height >= height);
    });
    if (resizedThumbnailSize &&
        resizedThumbnailSize.name !== currentThumbnailSizeName) {
        return url.replace("".concat(currentThumbnailSizeName, ".jpg"), "".concat(resizedThumbnailSize.name, ".jpg"));
    }
    return url;
}
exports.default = resizeYoutubeThumbnail;
//# sourceMappingURL=resize-youtube-thumbnail.js.map